import React, { useEffect, useState } from 'react';
import {
    CircularProgress, Grid,
    IconButton,
    Paper,
    Switch,
    TextField,
    Typography,
} from '@material-ui/core';
import {Alert, Autocomplete} from '@material-ui/lab';
import LaunchIcon from '@material-ui/icons/Launch';
import ClearIcon from '@material-ui/icons/Clear';
import CheckIcon from '@material-ui/icons/Check';
import RefreshIcon from '@material-ui/icons/Refresh';
import MaterialTable from 'material-table';
import useStyles from '../styles/styles';
import {useQuery, useMutation} from '@apollo/react-hooks';
import {gql} from 'apollo-boost';
import TableIcons from '../utils/TableIcons';
import theme from '../styles/theme';
import getEnvironment from "../utils/getEnvironment";
import _ from 'lodash';

const PayoutStrategySwappers = () => {
    const classes = useStyles();
    const env = getEnvironment();
    const [manualLoad, setManualLoad] = useState(false);
    const {loading, error, data, refetch} = useQuery(gql`
        query PayoutStrategySwappers {
            payoutStrategySwappers {
                criteria
                canSwapTo
            }
        }
    `, {
        notifyOnNetworkStatusChange: true,
        context: {
            clientName: "kgraphql"
        }
    });

    useEffect(() => {
        if (!loading && manualLoad) {
            setManualLoad(false);
        }
    }, [loading]);


    const PayoutStrategySwapperTable = () => (
        <MaterialTable
            title=""
            icons={TableIcons}
            columns={[
                {title: 'Swap Criteria', field: "criteria"},
                {title: "Potential Swapped Strategies", field: "canSwapTo",},
            ]}
            data={data.payoutStrategySwappers.map(swapper => ({
                criteria: swapper.criteria,
                canSwapTo: swapper.canSwapTo,
            }))}
            actions={[
                {
                    icon: () => <RefreshIcon/>,
                    tooltip: 'Refetch Data',
                    isFreeAction: true,
                    onClick: (event) => refetch()
                },
            ]}
            options={{
                addRowPosition: 'first',
                pageSize: 100,
                pageSizeOptions: [100, 200, 300],
                headerStyle: {
                    minWidth: 'auto',
                }
            }}
        />
    );

    return (
        <>
            <Typography variant="h2">
                Payout Strategy Swappers
            </Typography>
            {(!loading && error) ? (
                <Paper className={classes.paper}>
                    <Alert severity="error">There is an error!</Alert>
                    <pre>{JSON.stringify((error), null, 2)}</pre>
                </Paper>
            ) : null}
            {loading || manualLoad ? (
                <Paper className={classes.paper}>
                    <div className={classes.loadingBar}>
                        <CircularProgress
                            size={50}
                            thickness={4}
                        />
                    </div>
                </Paper>
            ) : null}
            {!manualLoad && data && data.payoutStrategySwappers ? (
                <PayoutStrategySwapperTable/>
            ) : null}
        </>
    );
};

export default PayoutStrategySwappers;
